<template>
<v-combobox ref="combobox" v-model="selected" :items="stockItems"
            item-text="name" item-value="id" return-object
            :search-input.sync="search"
            :label="label" placeholder="Search or create a new item"
            clearable hide-details :filter="itemFilter"
            v-bind="$attrs"
            @keyup.enter.native="$refs.combobox.blur()">
  <template v-slot:no-data>
    <v-list-item v-if="search">
      <v-list-item-content>
        <v-list-item-title>
          <em>{{ search }}</em> — hit enter to create
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </template>
</v-combobox>
</template>

<script>
import * as api from '../../api'

export default {
  name: 'StockItemSelect',
  inheritAttrs: false,
  props: {
    value: { type: [Object, String], default: null },
    label: { type: String, default: 'Item' }
  },
  data() {
    return {
      selected: this.value,
      search: '',
      stockItems: []
    }
  },
  watch: {
    selected(val) {
      this.$emit('input', val)
    },
    value(val) {
      this.selected = val
    }
  },
  methods: {
    itemFilter(item, queryText) {
      return item.name.toLowerCase().includes(queryText.toLowerCase())
    },
    blur() {
      this.$refs.combobox.blur()
    },
    async resolveAndClear() {
      const value = this.selected || this.search
      if (!value) return null
      this.selected = null
      this.search = ''
      this.$refs.combobox.blur()
      if (typeof value === 'string') {
        await api.post('/stock-item', { name: value })
        this.stockItems = await api.get('/stock-items')
        return this.stockItems.find(i => i.name === value)
      }
      return value
    }
  },
  async created() {
    this.stockItems = await api.get('/stock-items')
    if (this.selected && this.selected.id) {
      this.selected = this.stockItems.find(i => i.id === this.selected.id) || this.selected
    }
  }
}
</script>
